import React, { Component } from 'react';

export default class Overlay extends Component {
	constructor(props) {
		super(props);
		this.state = {

		}
	}

	render() {
		let overlay_style = {
			zIndex: 0,
			backgroundColor: this.props.backgroundColor != null ? this.props.backgroundColor : 'white',
			height: this.props.height,
			width: this.props.width,
		}

		return (
			<div id='overlay' style={overlay_style}>
				{this.props.children}
			</div>
		)
	}
}
